(function () {
  'use strict';
  var EASE_OUT = 'cubic-bezier(.22,1,.36,1)';
  var EASE_IN_OUT = 'cubic-bezier(.45,0,.2,1)';

  function hydrate(img) {
    if (!img || !img.getAttribute('data-src')) return;
    var ss = img.getAttribute('data-srcset');
    if (ss) img.srcset = ss;
    img.src = img.getAttribute('data-src');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }
  function ready(img, ms) {
    return new Promise(function (resolve) {
      if (!img) return resolve();
      hydrate(img);
      if (img.complete && img.naturalWidth) return resolve();
      var done = false;
      function fin() { if (!done) { done = true; resolve(); } }
      img.addEventListener('load', fin, { once: true });
      img.addEventListener('error', fin, { once: true });
      setTimeout(fin, ms || 700);
    });
  }

  function init(root) {
    if (root.getAttribute('data-vhl-bound')) return;
    root.setAttribute('data-vhl-bound', '1');

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var stage = root.querySelector('[data-stage]');
    var live = root.querySelector('[data-live]');
    var pp = root.querySelector('[data-pp]');
    var panel = root.querySelector('[role="tabpanel"]');
    var tabs = [].slice.call(root.querySelectorAll('[data-tab]'));
    var sets = {};
    ['s', 'b'].forEach(function (k) {
      var thumbsRow = root.querySelector('.vhl__thumbs[data-cat="' + k + '"]');
      sets[k] = {
        slides: [].slice.call(root.querySelectorAll('.vhl__slide[data-cat="' + k + '"]')),
        infos: [].slice.call(root.querySelectorAll('.vhl__info[data-cat="' + k + '"]')),
        thumbs: thumbsRow ? [].slice.call(thumbsRow.querySelectorAll('.vhl__thumb')) : [],
        row: thumbsRow,
        head: root.querySelector('.vhl__head[data-cat="' + k + '"]'),
        all: root.querySelector('.vhl__all[data-cat="' + k + '"]'),
        i: 0
      };
    });
    if (!stage || !sets.s.slides.length) return;

    var cat = 's';
    var wantPlay = !reduce;
    var held = { hover: false, focus: false, offscreen: false, hidden: document.hidden };
    var running = [];

    function setOn(list, i) { list.forEach(function (el, n) { el.classList.toggle('is-on', n === i); }); }
    function thumbBox(k, i) {
      var t = sets[k].thumbs[i];
      var img = t && t.querySelector('.vhl__tbox');
      return (img || t) ? (img || t).getBoundingClientRect() : null;
    }
    function toThumb(k, i) {
      var s = stage.getBoundingClientRect();
      var t = thumbBox(k, i);
      if (!t || !t.width || !s.width) return 'scale(.86)';
      var dx = (t.left + t.width / 2) - (s.left + s.width / 2);
      var dy = (t.top + t.height / 2) - (s.top + s.height / 2);
      return 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + (t.width / s.width).toFixed(4) + ')';
    }
    function settle() {
      running.forEach(function (a) { try { a.cancel(); } catch (e) {} });
      running = [];
      root.querySelectorAll('.vhl__slide.is-moving').forEach(function (el) { el.classList.remove('is-moving'); });
    }
    function track(anim, el, after) {
      running.push(anim);
      anim.onfinish = function () {
        running = running.filter(function (a) { return a !== anim; });
        if (after) after(el);
      };
      return anim;
    }
    function restartClock() {
      var bar = root.querySelector('.vhl__thumbs.is-on .vhl__thumb.is-on .vhl__bar');
      if (!bar) return;
      bar.style.animation = 'none';
      void bar.offsetWidth;
      bar.style.animation = '';
    }
    function applyHold() {
      var h = held.hover || held.focus || held.offscreen || held.hidden;
      root.classList.toggle('is-playing', wantPlay);
      root.classList.toggle('is-held', h);
    }
    function announce(k, i) {
      if (!live) return;
      var name = sets[k].infos[i] && sets[k].infos[i].querySelector('.vhl__name');
      live.textContent = name ? name.textContent + ', ' + (i + 1) + ' of ' + sets[k].slides.length : '';
    }
    function preloadNext(k, i) {
      var n = sets[k].slides.length;
      if (n < 2) return;
      var nx = sets[k].slides[(i + 1) % n];
      hydrate(nx && nx.querySelector('img'));
    }

    var GROUND = 0.92, MAXW = 0.9, MAXH = 0.84;
    function fit(k, i) {
      var t = sets[k].thumbs[i];
      var timg = t && t.querySelector('.vhl__timg');
      var simg = sets[k].slides[i] && sets[k].slides[i].querySelector('.vhl__img');
      if (!timg || !simg || timg.getAttribute('data-fit') || !timg.complete || !timg.naturalWidth) return;
      timg.setAttribute('data-fit', '1');
      var n = 64, c = document.createElement('canvas'), x, d;
      c.width = c.height = n;
      try {
        x = c.getContext('2d', { willReadFrequently: true });
        x.fillStyle = '#fff'; x.fillRect(0, 0, n, n);
        x.drawImage(timg, 0, 0, n, n);
        d = x.getImageData(0, 0, n, n).data;
      } catch (e) { return; }
      var l = n, r = -1, tp = n, b = -1;
      for (var y = 0; y < n; y++) {
        for (var xx = 0; xx < n; xx++) {
          var o = (y * n + xx) * 4;
          if (255 - Math.min(d[o], d[o + 1], d[o + 2]) > 40) {
            if (xx < l) l = xx; if (xx > r) r = xx; if (y < tp) tp = y; if (y > b) b = y;
          }
        }
      }
      if (r < 0) return;
      var g = [], gi;
      for (gi = 0; gi < n; gi += 3) {
        [[gi, 0], [gi, n - 1], [0, gi], [n - 1, gi]].forEach(function (p) {
          var q = (p[1] * n + p[0]) * 4;
          g.push(Math.min(d[q], d[q + 1], d[q + 2]));
        });
      }
      g.sort(function (a, bb) { return a - bb; });
      var ground = g[Math.floor(g.length / 2)];
      if (ground >= 240 && ground < 255) {
        var lift = 'brightness(' + Math.min(1.06, 255 / ground).toFixed(3) + ')';
        simg.style.filter = lift;
        timg.style.filter = lift;
      }
      l /= n; r = (r + 1) / n; tp /= n; b = (b + 1) / n;
      var s = Math.min(MAXW / (r - l), MAXH / (b - tp));
      s = Math.max(0.8, Math.min(1.25, s));
      var tx = -((l + r) / 2 - 0.5) * s;
      var ty = GROUND - (0.5 + (b - 0.5) * s);
      var tf = 'translate(' + (tx * 100).toFixed(2) + '%,' + (ty * 100).toFixed(2) + '%) scale(' + s.toFixed(3) + ')';
      simg.style.transform = tf;
      timg.style.transform = tf;
    }
    ['s', 'b'].forEach(function (k) {
      sets[k].thumbs.forEach(function (t, m) {
        var timg = t.querySelector('.vhl__timg');
        if (!timg) return;
        if (timg.complete && timg.naturalWidth) fit(k, m);
        else timg.addEventListener('load', function () { fit(k, m); }, { once: true });
      });
    });

    function go(i, user) {
      var S = sets[cat];
      var n = S.slides.length;
      if (!n) return;
      i = (i + n) % n;
      if (i === S.i) { if (user) restartClock(); return; }
      var prevI = S.i;
      var prev = S.slides[prevI];
      var next = S.slides[i];
      S.i = i;
      setOn(S.thumbs, i);
      S.thumbs.forEach(function (t, m) { if (m === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      setOn(S.infos, i);
      if (user) announce(cat, i);

      ready(next.querySelector('img'), 600).then(function () {
        if (S.i !== i || cat !== next.getAttribute('data-cat')) return;
        var fromT = getComputedStyle(prev).transform;
        var fromO = getComputedStyle(prev).opacity;
        settle();
        S.slides.forEach(function (el) { if (el !== next) el.classList.remove('is-on'); });
        prev.classList.add('is-moving');
        next.classList.add('is-on');
        if (reduce || !prev.animate) {
          if (prev.animate) {
            track(prev.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 240, easing: 'linear' }), prev, function (el) { el.classList.remove('is-moving'); });
            track(next.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 240, easing: 'linear' }), next);
          } else {
            prev.classList.remove('is-moving');
          }
        } else {
          track(prev.animate([
            { transform: fromT === 'none' ? 'none' : fromT, opacity: +fromO },
            { opacity: 0, offset: 0.55 },
            { transform: toThumb(cat, prevI), opacity: 0 }
          ], { duration: 520, easing: EASE_IN_OUT }), prev, function (el) { el.classList.remove('is-moving'); });
          track(next.animate([
            { transform: toThumb(cat, i), opacity: 0 },
            { opacity: 1, offset: 0.38 },
            { transform: 'none', opacity: 1 }
          ], { duration: 760, delay: 70, easing: EASE_OUT, fill: 'backwards' }), next);
        }
        restartClock();
        preloadNext(cat, i);
      });
    }

    function switchCat(k, focus) {
      if (k === cat || !sets[k] || !sets[k].slides.length) return;
      var from = sets[cat];
      var to = sets[k];
      var out = from.slides[from.i];
      var inn = to.slides[to.i];
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-tab') === k;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && panel) panel.setAttribute('aria-labelledby', t.id);
        if (on && focus) t.focus();
      });
      root.setAttribute('aria-labelledby', 'vhl-h-' + k + '-' + root.getAttribute('data-uid'));
      cat = k;
      root.setAttribute('data-cat', k);
      wake(k);
      [from.head, from.all, from.row].forEach(function (el) { if (el) el.classList.remove('is-on'); });
      from.infos.forEach(function (el) { el.classList.remove('is-on'); });
      [to.head, to.all, to.row].forEach(function (el) { if (el) el.classList.add('is-on'); });
      setOn(to.infos, to.i);
      setOn(to.thumbs, to.i);
      to.thumbs.forEach(function (t, m) { if (m === to.i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      announce(k, to.i);

      ready(inn.querySelector('img'), 650).then(function () {
        if (cat !== k) return;
        settle();
        root.querySelectorAll('.vhl__slide.is-on').forEach(function (el) { if (el !== inn) el.classList.remove('is-on'); });
        out.classList.add('is-moving');
        inn.classList.add('is-on');
        if (!inn.animate) { out.classList.remove('is-moving'); return; }
        if (reduce) {
          track(out.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 240 }), out, function (el) { el.classList.remove('is-moving'); });
          track(inn.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 240 }), inn);
        } else {
          track(out.animate([
            { transform: 'none', opacity: 1 },
            { transform: 'translateY(3%) scale(.9)', opacity: 0 }
          ], { duration: 320, easing: EASE_IN_OUT }), out, function (el) { el.classList.remove('is-moving'); });
          track(inn.animate([
            { transform: 'translateY(-2%) scale(.9)', opacity: 0 },
            { opacity: 1, offset: 0.45 },
            { transform: 'none', opacity: 1 }
          ], { duration: 720, delay: 150, easing: EASE_OUT, fill: 'backwards' }), inn);
          to.thumbs.forEach(function (t, m) {
            t.animate([{ transform: 'translateY(10px)', opacity: 0 }, { transform: 'none', opacity: 1 }],
              { duration: 420, delay: 160 + m * 40, easing: EASE_OUT, fill: 'backwards' });
          });
        }
        restartClock();
        preloadNext(k, to.i);
      });
    }

    var woken = { s: true };
    function wake(k) {
      if (woken[k]) return;
      woken[k] = true;
      sets[k].thumbs.forEach(function (t) { hydrate(t.querySelector('img')); });
      hydrate(sets[k].slides[sets[k].i] && sets[k].slides[sets[k].i].querySelector('img'));
    }

    root.setAttribute('data-uid', (root.getAttribute('aria-labelledby') || '').replace(/^vhl-h-s-/, ''));
    tabs.forEach(function (t, n) {
      var k = t.getAttribute('data-tab');
      t.addEventListener('click', function () { switchCat(k, false); });
      t.addEventListener('pointerenter', function () { wake(k); });
      t.addEventListener('focus', function () { wake(k); });
      t.addEventListener('pointerdown', function () { wake(k); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          var nx = tabs[(n + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          switchCat(nx.getAttribute('data-tab'), true);
        }
      });
    });
    ['s', 'b'].forEach(function (k) {
      sets[k].thumbs.forEach(function (t, m) {
        t.addEventListener('click', function () { if (cat === k) go(m, true); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          var n = sets[k].thumbs.length;
          var nx = (m + (e.key === 'ArrowRight' ? 1 : n - 1)) % n;
          sets[k].thumbs[nx].focus();
          go(nx, true);
        });
      });
    });
    if (pp) {
      pp.addEventListener('click', function () {
        wantPlay = !wantPlay;
        pp.setAttribute('aria-pressed', wantPlay ? 'false' : 'true');
        pp.setAttribute('aria-label', wantPlay ? 'Pause the lineup' : 'Play the lineup');
        if (wantPlay) restartClock();
        applyHold();
      });
      if (!wantPlay) { pp.setAttribute('aria-pressed', 'true'); pp.setAttribute('aria-label', 'Play the lineup'); }
    }
    root.addEventListener('animationend', function (e) {
      if (e.animationName !== 'vhl-clock' || !wantPlay) return;
      go(sets[cat].i + 1, false);
    });

    var sx = 0, sy = 0, swiped = false, downAt = 0;
    stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; swiped = false; downAt = Date.now(); });
    stage.addEventListener('pointerup', function (e) {
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (Math.abs(dx) > 36 && Math.abs(dx) > Math.abs(dy) * 1.2 && Date.now() - downAt < 900) {
        swiped = true;
        go(sets[cat].i + (dx < 0 ? 1 : -1), true);
      }
    });
    stage.addEventListener('click', function (e) { if (swiped) { e.preventDefault(); swiped = false; } }, true);
    stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { held.hover = true; applyHold(); } });
    stage.addEventListener('pointerleave', function () { held.hover = false; applyHold(); });
    root.addEventListener('focusin', function (e) { if (e.target.matches && e.target.matches(':focus-visible')) { held.focus = true; applyHold(); } });
    root.addEventListener('focusout', function () { held.focus = false; applyHold(); });
    document.addEventListener('visibilitychange', function () { held.hidden = document.hidden; applyHold(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        held.offscreen = !es[0].isIntersecting;
        applyHold();
      }, { threshold: 0.35 }).observe(root);
    }

    root.classList.add('is-ready');
    applyHold();
    var first = sets.s.slides[0].querySelector('img');
    ready(first, 2500).then(function () { preloadNext('s', 0); });
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-vhl]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
